export default __webpack_public_path__ + "static/media/chart_soso.20bc2a56.png";